export default "__VITE_ASSET__575c0ee1__"